import React from "react";

import Experience from "../components/Experience";
import Home from "../components/Home";
import NavBar from "../components/NavBar";
import Portfolio from "../components/Portfolio";

import About from "../components/About";

const Homepage = () => {
  return (
    <div>
      <NavBar />
      <Home />
      <About />
      <Portfolio />
      <Experience />
    </div>
  );
};

export default Homepage;
